// @flow
import { AvailabilityStatus } from '../../core/constants';
import * as r from 'ramda';
import * as rA from 'ramda-adjunct';

export type ExactMatchDomain = {

};

export type SuggestionDomain = {

};

export type Domain = ExactMatchDomain | SuggestionDomain;

export const mapFqdnAvailableToStatus = (available: boolean) => {
  return r.cond([
    [ r.equals(true), r.always(AvailabilityStatus.AVAILABLE) ],
    [ r.equals(false), r.always(AvailabilityStatus.UNAVAILABLE) ],
  ])(available);
};


export const isPremium = (domain: Domain): boolean => {
  return r.anyPass([
    r.propEq('availability_label', 'registry_premium'),
    r.propEq('availability_label', 'auction'),
    r.pipe(
      r.propOr('', 'inventory'),
      // eslint-disable-next-line no-underscore-dangle
      r.contains(r.__, [ 'registry_premium', 'premium' ]),
    ),
  ])(domain);
};

export const isPromo = (domain: Domain): boolean => {
  const price = rA.dispatch([
    r.path([ 'price', 'gross' ]),
    r.prop('price'),
  ])(domain);
  const oldPrice = rA.dispatch([
    r.path([ 'oldPrice', 'gross' ]),
    r.prop('oldPrice'),
  ])(domain);

  return r.and(
    rA.isNotNil(oldPrice),
    r.gt(oldPrice, price),
  );
};
